import React, { useState, useEffect, useRef } from "react";
import './saveProgressModal.css';

export default function SaveProgressModal({ email, phone, isOpen, generatedOtp, onVerify, onSkip }) {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState(false);
  const otpRefs = useRef([]);

  useEffect(() => {
    if (isOpen) {
      setOtp(["", "", "", "", "", ""]);
      setError(false);
      otpRefs.current[0]?.focus();
    }
  }, [isOpen]);

  const handleOtpChange = (e, idx) => {
    const val = e.target.value;
    if (/^[0-9]?$/.test(val)) {
      const newOtp = [...otp];
      newOtp[idx] = val;
      setOtp(newOtp);
      if (val && idx < 5) otpRefs.current[idx + 1]?.focus();
    }
  };

  const handleVerify = () => {
    console.log("Verifying OTP:", otp.join(""), "against generated OTP:", generatedOtp);
    if (otp.join("") == generatedOtp) {
      setError(false);
      onVerify();
      console.log("OTP verified successfully!");
    } else {
      setError(true);
      console.log("Incorrect OTP entered.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="otp-modal-verify fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-11/12 max-w-md p-6 relative">
        <div className="otp-modal-icon text-3xl mb-3 flex justify-center">✦</div>
        <h2 className="text-xl font-semibold mb-2 text-center">Save Your Progress</h2>
        <p className="text-sm text-gray-600 mb-4 text-center">
          A 6-digit verification code has been sent to your email{" "}
          <strong>{email}{phone ? ` & ${phone}` : ""}</strong>.<br />
          Enter it below so you can return to this form anytime using just your email.
        </p>

        {/* Demo mode */}
        {/* <div className="otp-demo-box rounded-md p-3 text-center mb-4">
          <p className="text-xs text-gray-500 mb-1">Demo mode — your code is</p>
          <div className="font-mono text-lg text-indigo-600">{generatedOtp}</div>
        </div> */}

        {/* OTP Inputs */}
        <div className="otp-modal-inputs flex justify-center gap-2 mb-3">
          {otp.map((digit, idx) => (
            <input
              key={idx}
              ref={(el) => (otpRefs.current[idx] = el)}
              type="text"
              maxLength="1"
              inputMode="numeric"
              value={digit}
              onChange={(e) => handleOtpChange(e, idx)}
              className="w-12 h-12 text-center border-2 border-gray-300 rounded-lg text-lg focus:border-indigo-600 focus:ring-1 focus:ring-indigo-200 outline-none"
            />
          ))}
        </div>

        {error && (
          <div className="otp-modal-error text-red-600 text-sm mb-3 text-center">
            Incorrect code — please try again.
          </div>
        )}

        <button
          onClick={handleVerify}
          className="w-full otp-modal-btn py-3 rounded-xl mb-2 transition"
        >
          Verify & Continue → 
        </button>
        {/* <button
          onClick={onSkip}
          className="w-full otp-modal-skip text-sm underline hover:text-gray-800"
        >
          Skip for now (progress won't be saved)
        </button> */}
      </div>
    </div>
  );
}